import React, { useEffect } from "react";

import "./ChooseYourPlan.css";
import { useLanguage } from "../context/LanguageContext";

// const packs = [
//   { id: "0", name: "BestIndie Daily", price: "3.15 AED/Daily" },
//   { id: "1", name: "BestIndie Weekly", price: "12.6 AED/Week" },
//
//   // Add more packs here
// ];

const ChooseYourPlan = (props) => {
    const { language } = useLanguage();

    let packs = []; // Declare packs outside the conditional block

    if (language === 'en') {
        packs = [
            { id: "0", name: "BestIndie Daily", price: "3.15 AED/Daily" },
            { id: "1", name: "BestIndie Weekly", price: "12.6 AED/Week" },
        ];
    } else {
        packs = [
            { id: "0", name: "BestIndie Daily", price: "3.25 د إ/يوميا" },
            { id: "1", name: "BestIndie Weekly", price: "12.6 درهم اماراتي/ أسبوعيا" },
        ];
    }

    useEffect(() => console.log("pack value received is -->", props.pack), [
        props.pack,
    ]);

    const onOptionChange = (e) => {
        const selectedPackId = e.target.value;
        const selectedPack = packs.find((pack) => pack.id === selectedPackId);

        if (selectedPack) {
            props.setPack(selectedPackId);
            localStorage.setItem("selectedPack", selectedPackId);
            localStorage.setItem("selectedPackPrice", selectedPack.price); // Save the price in localStorage
            console.log("Selected pack value saved:", selectedPackId, selectedPack.price); // Log pack value
        }
    };

    useEffect(() => {
        if (packs.length > 0) {
            const singlePack = packs[0];
            props.setPack(singlePack.id);
            localStorage.setItem("selectedPack", singlePack.id);
            localStorage.setItem("selectedPackPrice", singlePack.price);
        }
    }, []);

    return language === "en" ? (
        <div className="choosePlan_section_en">
            <div className="row">
                <div className="col-lg-12">
                    <h3>Choose your subscription</h3>
                </div>
            </div>

            <div className="plans_boxes">
                <div className="row">
                    {packs.map((pack) => (
                        <div className="col-lg-4" key={pack.id}>
                            <label className="box">
                                <div className="radio-text">
                                    <div className="radio-title">
                                        <h4 className="plan-name">{pack.name}</h4>
                                    </div>

                                    <div className="radio-pricepoint">
                                        <span>{pack.price}</span>
                                    </div>
                                </div>
                                <div className="radio-button">
                                    <label className="radio-container">
                                        <input
                                            id={pack.id}
                                            onChange={(e) => onOptionChange(e)}
                                            value={pack.id}
                                            type="radio"
                                            name="choose"
                                            checked={props.pack === pack.id}
                                        />
                                        <span className="radio-checkcircle"></span>
                                    </label>
                                </div>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    ) : (
        <div className="choosePlan_section_ar">
            <div className="row">
                <div className="col-lg-12">
                    <h3 className="h3-subscription">اختر اشتراكك</h3>
                </div>
            </div>

            <div className="plans_boxes">
                <div className="row">
                    {packs.map((pack) => (
                        <div className="col-lg-4" key={pack.id}>
                            <label className="box">
                                <div className="radio-text">
                                    <div className="radio-title">
                                        <h4 className="plan-name">{pack.name}</h4>
                                    </div>

                                    <div className="radio-pricepoint">
                                        <span>{pack.price}</span>
                                    </div>
                                </div>
                                <div className="radio-button">
                                    <label className="radio-container">
                                        <input
                                            id={pack.id}
                                            onChange={(e) => onOptionChange(e)}
                                            value={pack.id}
                                            type="radio"
                                            name="choose"
                                            checked={props.pack === pack.id}
                                        />
                                        <span className="radio-checkcircle"></span>
                                    </label>
                                </div>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChooseYourPlan;
